import React from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { CancellationReasonType } from 'common/billing/interfaces/cancellationReasons'
import { analyticsService } from 'utils/services/analytics'

import { OfferStepTypes } from '../../types'

import BadExpirence from './modals/BadExpirence'
import GuideTours from './modals/GuideTours'
import PageProblems from './modals/PageProblems'

interface IOfferStep {
  reason: CancellationReasonType | null
  onClose: () => void
  onNextStep: () => void
}

const OfferStep = ({ reason, onClose, onNextStep }: IOfferStep) => {
  const offerType = React.useMemo(() => {
    switch (reason) {
      case CancellationReasonType.PAGE_PROBLEMS:
        return OfferStepTypes.FACEBOOK_BLOCKED

      case CancellationReasonType.BAD_PRODUCT:
      case CancellationReasonType.BAD_RESULT:
      case CancellationReasonType.BAD_UNDERSTANDING:
        return OfferStepTypes.GUIDES

      default:
        return OfferStepTypes.SUPPORT
    }
  }, [reason])

  const handleClose = () => {
    onClose()
    analyticsService.sendEvent(`SETTINGS.BILLING.CANCEL_MODAL.${offerType}.CLOSE`)
  }

  const handleChangeStep = () => {
    onNextStep()
    analyticsService.sendEvent(`SETTINGS.BILLING.CANCEL_MODAL.${offerType}.NEXT`)
  }

  React.useEffect(() => {
    analyticsService.sendEvent(`SETTINGS.BILLING.CANCEL_MODAL.${offerType}.SHOW`)
  }, [offerType])

  return (
    <>
      {offerType === OfferStepTypes.FACEBOOK_BLOCKED && <PageProblems />}
      {offerType === OfferStepTypes.GUIDES && <GuideTours />}
      {offerType === OfferStepTypes.SUPPORT && <BadExpirence />}
      <div className="p-y-xs p-x b-t row between">
        <BtnV2 onClick={handleClose}>{l.translate('I changed my mind')}</BtnV2>
        <BtnV2 onClick={handleChangeStep} variant="primary">
          {l.translate('Next')}
        </BtnV2>
      </div>
    </>
  )
}

export default OfferStep
